import { render, staticRenderFns } from "./SubmissionAccordion.vue?vue&type=template&id=1405f39f&scoped=true&"
import script from "./SubmissionAccordion.vue?vue&type=script&lang=js&"
export * from "./SubmissionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionAccordion.vue?vue&type=style&index=0&id=1405f39f&lang=scss&scoped=true&"
import style1 from "./SubmissionAccordion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1405f39f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1405f39f')) {
      api.createRecord('1405f39f', component.options)
    } else {
      api.reload('1405f39f', component.options)
    }
    module.hot.accept("./SubmissionAccordion.vue?vue&type=template&id=1405f39f&scoped=true&", function () {
      api.rerender('1405f39f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/SubmissionAccordion.vue"
export default component.exports